import { Component } from '@angular/core';
import { inject } from '@angular/core';
import { Router } from '@angular/router'
import { FormsModule } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication.service';
import { NgIf } from '@angular/common';
import { ApplicationService } from '../../services/application.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, NgIf],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  constructor(private authenticationService: AuthenticationService, private applicationService:ApplicationService) {
    this.router = inject(Router);
  }

  router:Router
  isBusy:boolean = false;
  username:string = "";
  password:string = "";
  isInvalidLogin:boolean = false;

  async loginClicked() {
    this.isBusy = true;
    this.applicationService.showGlobalSpinner();
    this.isInvalidLogin =false;
    let user:any = await this.authenticationService.login(this.username, this.password);
    if(user != null) {
      this.authenticationService.loggedInUser = { username: user.userName };
      this.authenticationService.setIsAuthenticated(user.userName);
      this.authenticationService.publishLogin();
      this.router.navigate(['/home']);
    }
    else {
      this.username = "";
      this.password = "";
      this.isInvalidLogin = true;
    }

    this.isBusy = false;
    this.applicationService.hideGlobalSpinner();
  }

  logoutClicked() {
    this.authenticationService.logout();
    //Redirect to next location
    this.router.navigate(['/home'])
  }
}
